/**
 * @description Storage key enum
 */
export enum storageKeys {
  SampleLocal = 'SampleLocal',
  SampleSession = 'SampleSession',
  SampleCookies = 'SampleCookies',
  /** Accept Cookie Consent */
  AcceptCookieConsent = 'AcceptCookieConsent',
  /** 通路代碼 */
  ChannelId = 'ChannelId',
  /** ApplicationId */
  ApplicationId = 'ApplicationId',
  /** Line UID */
  LineUID = 'LineUID',
  /** 登入資訊 */
  LoginInfo = 'LoginInfo',
  /** 會員 ID */
  MemberId = 'MemberId',
  /** 我的收藏資訊 */
  MyFavorieState = 'MyFavorieState',
  /** 旅平險-投保作業暫存資料 */
  InsurceProcessState = 'InsurceProcessState',
  /** 首頁-公告是否已讀 */
  HomeAnnounceChecked = 'HomeAnnounceChecked',
  /** 旅平險-公告是否已讀 */
  TravelInsAnnounceChecked = 'TravelInsAnnounceChecked',
  /** 汽車險-公告是否已讀 */
  CarInsAnnounceChecked = 'CarInsAnnounceChecked',
  /** 機車險-公告是否已讀 */
  MotoInsAnnounceChecked = 'MotoInsAnnounceChecked',
  /** 行動裝置險-公告是否已讀 */
  MobileDeviceInsAnnounceChecked = 'MobileDeviceInsAnnounceChecked',
  /** 住火險-公告是否已讀 */
  FireInsAnnounceChecked = 'FireInsAnnounceChecked',
  /** 住火險-公告是否已讀 */
  PetInsAnnounceChecked = 'PetInsAnnounceChecked',
  /** 旅平險-優惠代碼 */
  TravelProgramCode = 'TravelProgramCode',
  /** 汽車險-優惠代碼  */
  CarProgramCode = 'CarProgramCode',
  /** 機車險-優惠代碼  */
  MotoProgramCode = 'MotoProgramCode',
  FireProgramCode = 'FireProgramCode',
  /** 行動裝置險-優惠代碼  */
  MobileDeviceProgramCode = 'MobileDeviceProgramCode',
  /** 寵物險-優惠代碼  */
  PetProgramCode = 'PetProgramCode',
  /** 投保日期區間資料 */
  InsuredRange = 'InsuredRange',
  /** 得獎公告代碼 */
  PrizeWinnerSn = 'PrizeWinnerSn',
  /** 汽車險-投保作業暫存資料 */
  InsurceProcessCarState = 'InsurceProcessCarState',
  /** 機車險-投保作業暫存資料 */
  InsurceProcessMotoState = 'InsurceProcessMotoState',
  /** 行動裝置險-投保作業暫存資料 */
  InsurceProcessMobileDeviceState = 'InsurceProcessMobileDeviceState',
  /** 住火險-投保作業暫存資料 */
  InsurceProcessFireState = 'InsurceProcessFireState',
  /** 寵物險-投保作業暫存資料 */
  InsurceProcessPetState = 'InsurceProcessPetState',
  /** 優惠活動-明細資料 */
  PromotionDetail = 'PromotionDetail',
  /** 最新消息-明細資料 */
  NewsDetail = 'NewsDetail',
  PolicyInquiry = 'PolicyInquiry',
  /** 優惠活動、最新消息頁面暫存資料 */
  TempInfo = 'TempInfo',
  /** 旅平險-投保作業-填寫中的商品代碼 */
  TravelActiveProdId = 'TravelActiveProdId',
  /** 汽車險-投保作業-填寫中的商品代碼 */
  CarActiveProdId = 'CarActiveProdId',
  /** 機車險-投保作業-填寫中的商品代碼 */
  MotoActiveProdId = 'MotoActiveProdId',
  /** 行動裝置險-投保作業-填寫中的商品代碼 */
  MobileDeviceActiveProdId = 'MobileDeviceActiveProdId',
  /** 住火險-投保作業-填寫中的商品代碼 */
  FireActiveProdId = 'FireActiveProdId',
  /** 寵物險-投保作業-填寫中的商品代碼 */
  PetActiveProdId = 'PetActiveProdId',
  /** 未經授權的 TOKEN 提示訊息 */
  UnauthorizedMsg = 'UnauthorizedMsg',
  /** 理賠服務事故日期 */
  ClaimAccidentDate = 'ClaimAccidentDate',
  /** 批改作業表單資料 */
  CorrectionFormVal = 'CorrectionFormVal',
  /** 當前語系紀錄 */
  Lng = 'Lng',
  /** 核心車籍資料 (上行電文) */
  Vehregdata = 'Vehregdata'
};
